module.exports = __webpack_public_path__ + "img/tips-devices.2f65acfb.svg";